import Vue from 'vue'
import Router from 'vue-router'
const Login = () => import('../views/Login.vue')
const MessageValidateCode = () => import('../views/MessageValidateCode.vue')
const Certification = () => import('../views/Certification.vue')
const TrialByInstallments = () => import('../views/TrialByInstallments.vue')
const ConsumptionVoucher = () => import('../views/ConsumptionVoucher.vue')
const ImageUpload = () => import('../views/ImageUpload.vue')
const Infomation = () => import('../views/Infomation.vue')
const SubmissionSuccess = () => import('../views/SubmissionSuccess.vue')

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login },
    { path: '/messageValidateCode', component: MessageValidateCode },
    { path: '/certification', component: Certification },
    { path: '/trialByInstallments', component: TrialByInstallments },
    { path: '/consumptionVoucher', component: ConsumptionVoucher },
    { path: '/imageUpload', component: ImageUpload },
    { path: '/infomation', component: Infomation },
    { path: '/submissionSuccess', component: SubmissionSuccess },
    { path: '*', redirect: '/login' }
  ]
})
